import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconDragThick = function IconDragThick(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-drag-thick"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 2C6.22386 2 6 2.22386 6 2.5V5.5C6 5.77614 6.22386 6 6.5 6H9.5C9.77614 6 10 5.77614 10 5.5V2.5C10 2.22386 9.77614 2 9.5 2H6.5ZM14.5 2C14.2239 2 14 2.22386 14 2.5V5.5C14 5.77614 14.2239 6 14.5 6H17.5C17.7761 6 18 5.77614 18 5.5V2.5C18 2.22386 17.7761 2 17.5 2H14.5ZM6 10.5C6 10.2239 6.22386 10 6.5 10H9.5C9.77614 10 10 10.2239 10 10.5V13.5C10 13.7761 9.77614 14 9.5 14H6.5C6.22386 14 6 13.7761 6 13.5V10.5ZM14.5 10C14.2239 10 14 10.2239 14 10.5V13.5C14 13.7761 14.2239 14 14.5 14H17.5C17.7761 14 18 13.7761 18 13.5V10.5C18 10.2239 17.7761 10 17.5 10H14.5ZM6 18.5C6 18.2239 6.22386 18 6.5 18H9.5C9.77614 18 10 18.2239 10 18.5V21.5C10 21.7761 9.77614 22 9.5 22H6.5C6.22386 22 6 21.7761 6 21.5V18.5ZM14.5 18C14.2239 18 14 18.2239 14 18.5V21.5C14 21.7761 14.2239 22 14.5 22H17.5C17.7761 22 18 21.7761 18 21.5V18.5C18 18.2239 17.7761 18 17.5 18H14.5Z",
    fill: "currentColor"
  })));
};

export { IconDragThick };
